export default () => ({
  isShow: false,
  showModal: false,
  isShowPrice: false,
  isShowProfile: false
})



// WEBPACK FOOTER //
// ./src/app/patient/profile-company-professional/components/Items/resources/data.js